import { render } from "./heroTxt.vue?vue&type=template&id=5042e16e&lang=true"
import script from "./heroTxt.vue?vue&type=script&lang=js"
export * from "./heroTxt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__